import { render, staticRenderFns } from "./BatchListComp.vue?vue&type=template&id=6e8194f6&scoped=true"
import script from "./BatchListComp.vue?vue&type=script&lang=js"
export * from "./BatchListComp.vue?vue&type=script&lang=js"
import style0 from "./BatchListComp.vue?vue&type=style&index=0&id=6e8194f6&prod&scoped=true&lang=css"
import style1 from "./BatchListComp.vue?vue&type=style&index=1&id=6e8194f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8194f6",
  null
  
)

export default component.exports